import React, {RefObject, useState} from 'react';
import {OpenPublishingTaskResult} from "../../../../../../services/tasks/models/tasksTypes";
import {CourseOrderLocalItemResult} from 'services/courseOrder/models/CourseOrderType';
import {tabsIds} from "../../orderPage.types";
import {useTranslation} from "react-i18next";
import {AdminTapActionsRef} from "../CourseOrderAdminView";
import {BackendServices} from "../../../../../../services";
import {useNavigate, useParams} from "react-router-dom";
import GenericActionsModal from "../../OrderTaskActionModals/GenericActionsModal";
import {TaskActionsNames} from "../../../../../../services/shared-models/sharedTypes";


function Actions({selectedTabId, openTask, courseOrderData, submitRef}: {
    selectedTabId: string;
    openTask: OpenPublishingTaskResult | null;
    courseOrderData: CourseOrderLocalItemResult | null;
    submitRef: RefObject<AdminTapActionsRef>;
}) {
    const {t} = useTranslation("Orders");
    const [loading, setLoading] = useState<boolean>(false);
    const {serialGID} = useParams();
    const navigate = useNavigate();
    const [openActionModal, setOpenActionModal] = useState<{
        isOpen: boolean;
        msg: string;
        type?: string;
        loading?: boolean;
    }>();
    return (
        <>
            {selectedTabId === tabsIds.info ? (
                <>
                    <button
                        key="RejectOrder"
                        disabled={loading}
                        onClick={async (e) => {
                            setOpenActionModal({isOpen: true, msg: t("rejectorder"), type: "rejectorder"});

                        }}
                        className="btn btn-outline-danger btn-sm rounded p-10-32P"
                    >
                        {t("rejectorder")}
                    </button>
                    <button
                        key="Return"
                        disabled={loading}
                        onClick={async (e) => {
                            setOpenActionModal({isOpen: true, msg: t("ReturnToAuthor"), type: "ReturnToAuthor"});
                        }}
                        className="btn btn-outline-primary btn-sm rounded p-10-32P"
                    >
                        {t("ReturnToAuthor")}
                    </button>
                    <button
                        key="Send"
                        disabled={loading}
                        onClick={async (e) => {
                            setOpenActionModal({isOpen: true, msg: t("Send"), type: "Send"});
                        }
                        }
                        className="btn btn-primary btn-sm rounded p-10-32P"
                    >
                        {t("Send")}
                    </button>
                </>
            ) : (
                <button
                    key="save"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        submitRef.current?.submit();
                    }}
                    className="btn btn-primary btn-sm rounded p-10-32P"
                >
                    {t("save")}
                </button>
            )}
            <GenericActionsModal
                isOpen={openActionModal !== undefined}
                onClose={() => setOpenActionModal(undefined)}
                isSubmitting={openActionModal?.loading ?? false}
                actionKey={openActionModal?.type}
                onSubmit={async (notes,filesIds ) => {
                    setOpenActionModal((mydata: any) => {
                        return {...mydata, loading: true}
                    });


                    if (openActionModal?.type === "Send") {

                        const res = await BackendServices.workflowService.WorkflowAction(openTask?.courseOrderId ?? 0, {
                            actionName: courseOrderData?.publishingOrderType?.id != 3 ? "NewRequest" : "OldRequest",
                            serialGuid: serialGID ?? "",
                            activityGuid: openTask?.activityGuid ?? "",
                            notes: notes ?? "",
                            filesIds: filesIds ?? [],
                        });
                        if (res.hasError) {
                            setOpenActionModal((mydata: any) => {
                                return {...mydata, loading: false}
                            });
                            return;
                        }
                    } else {

                        const res = await BackendServices.workflowService.WorkflowAction(openTask?.courseOrderId ?? 0, {
                            actionName: openActionModal?.type as TaskActionsNames,
                            serialGuid: serialGID ?? "",
                            activityGuid: openTask?.activityGuid ?? "",
                            notes: notes ?? "",
                            filesIds: filesIds ?? [],
                        });
                        if (res.hasError) {
                            setOpenActionModal((mydata: any) => {
                                return {...mydata, loading: false}
                            });
                            return;
                        }
                    }
                    setOpenActionModal((mydata: any) => {
                        return {...mydata, loading: false}
                    });
                    navigate(-1);


                }}
                type={openActionModal?.type}
                msg={openActionModal?.msg ?? ""}
            />

        </>
    );
}

export default Actions;